import { urlConfig } from '@config/url.config';
import AbstractAPI from './Abstract.api';

/**
 * Идентификатор корзины «без группы».
 *
 * В базе это состояние `group_id: null`, отдельной группы под него нет —
 * сервер отдаёт её в списке виртуально, под этим id. Раньше на её месте была
 * настоящая группа, id которой лежал в настройках пользователя.
 */
export const NO_GROUP_ID = 'none';

export interface IGroup {
    id: string;
    name: string;
    icon: number;
    /** Системная группа: корзина «без группы» или обёртка над аккаунтом Vega-M. */
    is_default: boolean;
}

/** Системную группу нельзя переименовать и удалить. */
export const isSystemGroup = (group: IGroup) =>
    group.id === NO_GROUP_ID || group.is_default;

export interface IGetUserGroupsRes {
    groups: IGroup[];
}

export interface ICreateGroupRes {
    id: string;
}

export interface IGroupeDescription {
    name: string;
    icon: number;
}

export class GroupsAPI extends AbstractAPI {
    async getUserGroups(token: string) {
        const pathname = 'group/get';
        const method = 'POST';
        const body: any = {
            token,
        };
        try {
            return await this._request<IGetUserGroupsRes>(
                pathname,
                method,
                body,
            );
        } catch (e) {
            throw new Error(e);
        }
    }
    async createGroup(token: string, name: string, icon: number) {
        const pathname = 'group/create';
        const method = 'POST';
        const body: any = {
            token,
            name,
            icon,
        };
        try {
            return await this._request<ICreateGroupRes>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async changeGroupDescription(
        token: string,
        group_id: string,
        description: IGroupeDescription,
    ) {
        const pathname = 'group/change_description';
        const method = 'POST';
        const body: any = {
            token,
            group_id,
            description,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async deleteGroup(token: string, id: string) {
        const pathname = 'group/delete';
        const method = 'POST';
        const body: any = {
            token,
            id,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async addDevice(token: string, imei: string, group_id: string) {
        const pathname = 'group/add_device';
        const method = 'POST';
        const body = {
            token,
            imei,
            group_id,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const groupsAPI = new GroupsAPI(urlConfig);
